import isString from '~~/helpers/dataStructure/isString';

export const capitalizeString = (inputString: string, separator: string): string => {

  if (!isString(inputString)) {

    return '';
  
  }
  const words = inputString.split(separator);
  const capitalizedWords = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join('');

  return capitalizedWords;

};
